import { useEffect, useState } from "react";

const fnFlyTo = (position, orientation) => {
    return {
        destination: Cesium.Cartesian3.fromRadians(position.lon, position.lat, position.height),
        orientation: {
            heading: orientation.heading,
            pitch: orientation.pitch,
            roll: orientation.roll
        },
        duration: 0
    }
}

const CesiumUIPune = (props) => {

    useEffect(async () => {
        const divElement = document.getElementById('cesiumContainer');
        divElement.innerHTML = '';
        Cesium.Ion.defaultAccessToken = props.accessToken;

        const viewer = new Cesium.Viewer("cesiumContainer", {
            terrain: Cesium.Terrain.fromWorldTerrain(),
            baseLayer: Cesium.ImageryLayer.fromWorldImagery({
              style: Cesium.IonWorldImageryStyle.AERIAL
            }),
        });
        viewer.animation.container.style.visibility = 'hidden';
        viewer.timeline.container.style.visibility = 'hidden';
        viewer.forceResize();
        props.setViewer(viewer);

        const scene = viewer.scene;
        const globe = scene.globe;
        globe.tileCacheSize = 200000;
        globe.maximumScreenSpaceError = 1.02;

        viewer.homeButton.viewModel.command.beforeExecute.addEventListener(
            function(e) {
                e.cancel = true;
                viewer.scene.camera.flyTo(fnFlyTo(props.homePosition, props.homeOrientation));
            });

        const waitForViewerDataSources = (maxRetries = 20, delay = 100) => {
            return new Promise((resolve, reject) => {
                let retries = 0;

                const check = () => {
                    if (viewer && viewer.dataSources) {
                        resolve();
                    } else if (retries++ < maxRetries) {
                        setTimeout(check, delay);
                    } else {
                        reject(new Error('viewer.dataSources not available in time'));
                    }
                };
                check();
            });
        }

        await waitForViewerDataSources();

        if(props.virtualCCZM.visibility) 
        {
            const kmlUrl = await Cesium.IonResource.fromAssetId(3680336);
            const dataSource = await Cesium.KmlDataSource.load(kmlUrl);
            viewer.dataSources.add(dataSource);
        }
        if(props.overheadTanks.visibility) {
            const kmlUrl = await Cesium.IonResource.fromAssetId(3682220);
            const dataSource = await Cesium.KmlDataSource.load(kmlUrl);
            viewer.dataSources.add(dataSource);
        }
        if(props.buildings.visibility) {
            const kmlUrl = await Cesium.IonResource.fromAssetId(3682262);
            const dataSource = await Cesium.KmlDataSource.load(kmlUrl);
            viewer.dataSources.add(dataSource);
        }

        viewer.scene.camera.flyTo(fnFlyTo(props.position, props.orientation));

    }, [props.counter]);

    return (
        <div id="cesiumContainer"></div>
    );
}

export default CesiumUIPune;